export default __webpack_public_path__ + "static/ERIN Logo-5317bf47d5e8277b5308fce509bb3bb6.png";